// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1fdZG","inner":"Footer_inner__I1RlI","nextIcon":"Footer_nextIcon__2_l30","innerLeft":"Footer_innerLeft__HXa9d"};